<template>
    <internal>

        <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing" />
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="mb-4 text-lg font-medium">Add Course Year</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-8">
                        <div class="col-span-8 sm:col-span-8">
                            <FormMultiselect
                                    label="Course Year"
                                    :options="options"
                                    track-key="id"
                                    label-key="title"
                                    :disabled="true"
                                    :required="true"
                                    :object="true"
                                    v-model="form.courseyear"
                                    :error="form.errors.courseyear"
                                />

                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'Status'"/>
                            <breeze-checkbox v-model="form.status" :checked="form.status"/>
                            <breeze-input-error :message="form.errors?form.errors.status:''" />
                        </div>
                    </div>
                    <breeze-button :disabled="form.processing">Submit</breeze-button>
                    <span v-if="form.recentlySuccessful" class="mx-4 text-green-500">Course Year Added!</span>
                    <exception />
                </form>
            </div>
        </div>
    </internal>
</template>

<script>
    import Internal from '@/Pages/Internal/Internal'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import ButtonLink from '@/Components/ButtonLink'
    import CardHeader from '@/Components/CardHeader'
    import { useForm } from '@inertiajs/inertia-vue3'
    import BreezeInputError from '@/Components/InputError'
    import BreezeButton from '@/Components/Button'
    import BreezeCheckbox from '@/Components/Checkbox'
    import Loading from '@/Components/Loading'
    import Exception from '@/Components/Exception'
    import BreezeTable from '@/Components/Table'
    import SelectList from '@/Components/SelectList'
    import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

    export default {
        components: {
            FormMultiselect,
            Internal,
            BreezeInput,
            BreezeLabel,
            ButtonLink,
            CardHeader,
            BreezeInputError,
            BreezeButton,
            BreezeCheckbox,
            Loading,
            Exception,
            BreezeTable,
            SelectList
        },
        props:['branchcourseyear'],
        data(){
            return{
                form: useForm({
                    courseyear:this.branchcourseyear.courseyear,
                    status: this.branchcourseyear.status,
                }),
                branchid:localStorage.branchId,
                fields:[{'key':'title','label':'Title'},{'key':'status','label':'Status'},{'key':'action','label':'Action'}]
            }
        },
        methods:{
            submitForm() {
                this.form.put(route('internal.courseyear.update',[this.branchid,this.branchcourseyear.id]),{
                    preserveScroll: true,
                    onSuccess: () => {this.form.reset(); location.reload()},
                });
            }
        },
        computed: {
            options(){
                return [{id:this.branchcourseyear.courseyear.id,title:this.branchcourseyear.courseyear.course.title+' - '+this.branchcourseyear.courseyear.title+' - '+this.branchcourseyear.courseyear.duration.start_month}];
            },
        },
    }
</script>
